(function () {
  var STORAGE_PREFIX = 'plp_load_more_v3:';
  var RESTORE_MAX_AGE_MS = 30 * 60 * 1000; // 30 minutes

  // ---------- URL / state helpers ----------
  function stripPageParam(search) {
    try {
      var params = new URLSearchParams(search || '');
      params.delete('page');
      var out = params.toString();
      return out ? ('?' + out) : '';
    } catch (e) {
      if (!search) return '';
      return search
        .replace(/([?&])page=\d+(&)?/g, function (_, p1, p2) { return p2 ? p1 : ''; })
        .replace(/\?&/, '?')
        .replace(/\?$/, '');
    }
  }

  function getContextKey() {
    // includes filters/sort in querystring (minus page)
    return STORAGE_PREFIX + window.location.pathname + stripPageParam(window.location.search);
  }

  function readState(key) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function writeState(key, state) {
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (e) {}
  }

  function removeState(key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }

  function isBackNavLikely() {
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation');
      if (nav && nav[0] && nav[0].type === 'back_forward') return true;
    } catch (e) {}
    return /\/products\//.test(document.referrer || '');
  }

  // ---------- Detect filter changes (including AJAX pushState) ----------
  function installHistoryListeners() {
    if (window.__plpLM_historyInstalled) return;
    window.__plpLM_historyInstalled = true;

    function fire() { window.dispatchEvent(new Event('plp:urlchange')); }

    var _push = history.pushState;
    history.pushState = function () {
      _push.apply(this, arguments);
      fire();
    };

    var _replace = history.replaceState;
    history.replaceState = function () {
      _replace.apply(this, arguments);
      fire();
    };

    window.addEventListener('popstate', fire);
  }

  // Some themes replace the grid/pagination without touching history,
  // so also watch for DOM swaps.
  function installMutationWatcher() {
    if (window.__plpLM_mutationInstalled) return;
    window.__plpLM_mutationInstalled = true;

    var ticking = false;

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.setTimeout(function () {
        ticking = false;
        window.dispatchEvent(new Event('plp:domchanged'));
      }, 50);
    }

    var target = document.querySelector('filter-container') || document.body;
    if (!target) return;

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        // Any change involving AjaxinateLoop / AjaxinatePagination means the results changed
        if (m.addedNodes && m.addedNodes.length) { schedule(); return; }
        if (m.removedNodes && m.removedNodes.length) { schedule(); return; }
      }
    });

    obs.observe(target, { childList: true, subtree: true });
  }

  // ---------- Core init ----------
  function initLoadMore(scope) {
    var root = (scope || document).querySelector('[data-load-more]');
    if (!root) return;

    // Prevent double-binding if init fires multiple times without DOM replacement
    if (root.__loadMoreInitDone) return;
    root.__loadMoreInitDone = true;

    var btn = root.querySelector('.js-load-more-btn');
    var nextLink = root.querySelector('.js-next-page');
    var status = root.querySelector('.js-load-more-status');
    var loop = document.querySelector('#AjaxinateLoop');

    if (!status || !loop) return;

    var stateKey = getContextKey();

    function hasFiltersActive() {
      // IMPORTANT: this comes from Liquid (data-has-filters)
      // so when filters are removed and the section re-renders, this flips to "false"
      return root.getAttribute('data-has-filters') === 'true';
    }

    function getNextUrl() {
      return nextLink ? (nextLink.getAttribute('href') || '') : '';
    }

    function getNumbers() {
      return {
        total: parseInt(root.getAttribute('data-total'), 10) || 0,
        perPage: parseInt(root.getAttribute('data-per-page'), 10) || 0,
        shown: parseInt(root.getAttribute('data-shown'), 10) || 0
      };
    }

    function setStatus(shown, total) {
      status.textContent = shown + ' of ' + total;
      root.setAttribute('data-shown', String(shown));
    }

    function setLoading(isLoading) {
      if (!btn) return;
      btn.disabled = isLoading;
      btn.classList.toggle('is-loading', isLoading);
      btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function updateLoadMoreUI() {
      var nums = getNumbers();
      var total = nums.total;
      var perPage = nums.perPage;

      // Clamp shown to total (important when filters removed and totals jump)
      var shown = Math.min(nums.shown, total);
      setStatus(shown, total);

      var filtersOn = hasFiltersActive();
      var nextUrl = getNextUrl();

      // Hide button when:
      // - no next page
      // - OR filters active AND everything fits on one page
      var shouldHideButton =
        (!nextUrl) ||
        (filtersOn && total > 0 && perPage > 0 && total <= perPage);

      if (btn) btn.style.display = shouldHideButton ? 'none' : '';
    }

    function saveState(extra) {
      var nums = getNumbers();
      var state = {
        ts: Date.now(),
        shown: nums.shown,
        total: nums.total,
        perPage: nums.perPage,
        nextUrl: getNextUrl(),
        scrollY: window.scrollY || 0
      };
      if (extra) for (var k in extra) state[k] = extra[k];
      writeState(stateKey, state);
    }

    // Save scroll position as they move around
    var scrollTimer = null;
    window.addEventListener('scroll', function () {
      if (scrollTimer) return;
      scrollTimer = window.setTimeout(function () {
        scrollTimer = null;
        saveState();
      }, 150);
    }, { passive: true });

    window.addEventListener('beforeunload', function () { saveState(); });

    // Snapshot state before navigating to a PDP
    loop.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (/\/products\//.test(href)) saveState({ clickedProductHref: href });
    });

    function appendNextPage(url) {
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newLoop = doc.querySelector('#AjaxinateLoop');
          if (newLoop) {
            while (newLoop.firstElementChild) loop.appendChild(newLoop.firstElementChild);
          }

          var newNext = doc.querySelector('#AjaxinatePagination .js-next-page');
          return (newNext && newNext.getAttribute('href')) ? newNext.getAttribute('href') : '';
        });
    }

    function restoreIfNeeded() {
      var state = readState(stateKey);
      if (!state) return;

      if (!state.ts || (Date.now() - state.ts) > RESTORE_MAX_AGE_MS) {
        removeState(stateKey);
        return;
      }

      if (!isBackNavLikely()) return;

      var nums = getNumbers();
      var total = nums.total;
      var perPage = nums.perPage;

      // If filters are active and only one page, never auto-load more
      if (hasFiltersActive() && total > 0 && perPage > 0 && total <= perPage) {
        updateLoadMoreUI();
        window.scrollTo(0, parseInt(state.scrollY, 10) || 0);
        return;
      }

      var targetShown = parseInt(state.shown, 10) || 0;
      var targetScrollY = parseInt(state.scrollY, 10) || 0;

      if (targetShown <= nums.shown) {
        updateLoadMoreUI();
        window.scrollTo(0, targetScrollY);
        return;
      }

      if (!nextLink || !getNextUrl()) {
        updateLoadMoreUI();
        window.scrollTo(0, targetScrollY);
        return;
      }

      setLoading(true);

      var shown = nums.shown;

      (function loadUntil() {
        var url = getNextUrl();
        if (!url) {
          if (btn) btn.remove();
          setLoading(false);
          updateLoadMoreUI();
          window.scrollTo(0, targetScrollY);
          return;
        }

        appendNextPage(url)
          .then(function (newNextUrl) {
            if (newNextUrl) nextLink.setAttribute('href', newNextUrl);
            else {
              nextLink.removeAttribute('href');
              if (btn) btn.remove();
            }

            if (perPage > 0 && total > 0) {
              shown = Math.min(total, shown + perPage);
              setStatus(shown, total);
            }

            saveState();
            updateLoadMoreUI();

            if (shown < targetShown && newNextUrl) loadUntil();
            else {
              setLoading(false);
              window.scrollTo(0, targetScrollY);
            }
          })
          .catch(function () {
            setLoading(false);
            updateLoadMoreUI();
            window.scrollTo(0, targetScrollY);
          });
      })();
    }

    // Click-to-load behavior
    if (btn && nextLink) {
      btn.addEventListener('click', function () {
        var url = getNextUrl();
        if (!url) return;

        var nums = getNumbers();
        var total = nums.total;
        var perPage = nums.perPage;
        var shown = nums.shown;

        setLoading(true);

        appendNextPage(url)
          .then(function (newNextUrl) {
            if (newNextUrl) nextLink.setAttribute('href', newNextUrl);
            else {
              nextLink.removeAttribute('href');
              btn.remove();
            }

            if (perPage > 0 && total > 0) {
              setStatus(Math.min(total, shown + perPage), total);
            }

            saveState();
            setLoading(false);
            updateLoadMoreUI();
          })
          .catch(function () {
            setLoading(false);
            updateLoadMoreUI();
          });
      });
    }

    // Initial UI sync + restore
    updateLoadMoreUI();
    restoreIfNeeded();

    window.addEventListener('pageshow', function (evt) {
      if (evt && evt.persisted) {
        updateLoadMoreUI();
        restoreIfNeeded();
      }
    });
  }

  // Re-init when filters are applied/removed so totals + has-filters flip correctly.
  // This is what makes XX of XX update when filters are removed.
  function reinitForNewResults() {
    // When the theme swaps markup, we want to allow init on the new element.
    // So we simply call initLoadMore(document); it will find the new root.
    initLoadMore(document);
  }

  installHistoryListeners();
  installMutationWatcher();

  document.addEventListener('DOMContentLoaded', function () {
    initLoadMore(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initLoadMore(evt.target);
  });

  // Filters removed/applied often triggers pushState/replaceState
  window.addEventListener('plp:urlchange', reinitForNewResults);

  // Some themes do DOM swaps without URL changes
  window.addEventListener('plp:domchanged', reinitForNewResults);
})();
